module.exports = __webpack_public_path__ + "static/media/shield-icon@3x.9387c200.png";